import { Component, Injector, ChangeDetectionStrategy } from '@angular/core';
import { Validators, FormArray } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ButtonActionsTypeEnum } from '@trendbuild/trend-z-api';
import { AbstractComponent } from 'lib-trend-core';

@Component({
    selector: 'app-send-buttons-attendance',
    // templateUrl: './send-buttons-attendance.component.html',
    templateUrl: './send-buttons-attendance.v2.component.html',
    styleUrl: './send-buttons-attendance.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SendButtonsAttendanceComponent extends AbstractComponent {

  createButton: boolean = false;

  constructor(
    injector: Injector,
    public dialogRef: MatDialogRef<SendButtonsAttendanceComponent>,
  ) {
    super(injector);
    this.createForm();
  }

  private createForm(): void {
    this.formGroup = this.formBuilder.group({
      title: ['', [Validators.required]],
      message: ['', [Validators.required]],
      footer: [''],
      buttonActions: this.formBuilder.array([])
    });
  }

  closeModal(): void {
    this.dialogRef.close();
  }

  createButtons(): void {
    this.createButton = true;
    if (this.getButtonActionsFormArray().length === 0) {
      this.addButtonAction();
    }
  }

  getButtonActionsFormArray() {
    return this.formGroup.get('buttonActions') as FormArray;
  }

  addButtonAction() {
    const buttonGroup = this.formBuilder.group({
      type: [ButtonActionsTypeEnum.reply, Validators.required],
      label: ['', Validators.required],
      phone: [''],
      url: ['']
    });

    buttonGroup.get('type').valueChanges.subscribe(type => {
      if (type === ButtonActionsTypeEnum.call) {
        buttonGroup.get('phone').setValidators([Validators.required]);
        buttonGroup.get('url').clearValidators();
      } else if (type === ButtonActionsTypeEnum.url) {
        buttonGroup.get('url').setValidators([Validators.required]);
        buttonGroup.get('phone').clearValidators();
      } else {
        buttonGroup.get('phone').clearValidators();
        buttonGroup.get('url').clearValidators();
      }
      buttonGroup.get('phone').updateValueAndValidity();
      buttonGroup.get('url').updateValueAndValidity();
    });

    this.getButtonActionsFormArray().push(buttonGroup);
  }

  removeButtonAction(index: number) {
    this.getButtonActionsFormArray().removeAt(index);
  }

  sendMessage() {
    if (!this.formGroup.valid) {
      this.validateAllFormFields(this.formGroup);
      return;
    }

    const message = {
      ...this.formGroup.value
    };

    this.dialogRef.close(message);
  }
}
